import React, { useState } from 'react';
import { Typography, Box } from '@mui/material';
import Image from 'next/image';
import useMediaQuery from '@mui/material/useMediaQuery';
// import HomeBg from '/public/images/home/homebg.svg';
import { useTheme } from '@mui/material/styles';
// import HomeTop from '/public/images/home/homeTop.svg';
import HomeTopic from '/public/images/home/homeTopic.svg';
import ThumbHome from '/public/images/home/thumbHome.png';
import { useTranslations } from 'next-intl';
import Container from 'components/Container';
import AppBar from '@mui/material/AppBar';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import SailEmail from '../SailEmail';
import { Topbar, Sidebar } from 'layouts/Main/components';
import pages from 'layouts/navigation';

const Hero = (): JSX.Element => {
  const t = useTranslations('Home');
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = (): void => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = (): void => {
    setOpenSidebar(false);
  };

  const open = isMd ? false : openSidebar;

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 38,
  });

  const FixedAppBar = () => (
    <>
      <AppBar
        position={'fixed'}
        sx={{
          top: 0,
          backgroundColor: trigger ? theme.palette.background.paper : 'red',
        }}
        elevation={trigger ? 1 : 0}
      >
        <Container paddingY={1}>
          <Topbar
            onSidebarOpen={handleSidebarOpen}
            pages={pages}
            colorInvert={false}
          />
        </Container>
      </AppBar>
      <Sidebar
        onClose={handleSidebarClose}
        open={open}
        variant="temporary"
        pages={pages}
      />
    </>
  );

  return (
    <>
      {trigger && <FixedAppBar />}
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          background: 'transparent',
        }}
      >
        <Box
          sx={{
            height: '100%',
            width: '100%',
            bgcolor: '#DFEBFF',
            position: 'absolute',
            backgroundSize: 'cover', // 让图片覆盖整个容器
            backgroundPosition: 'center', // 图片居中
            top: {
              xs: '-135px',
              sm: '-250px',
              md: '-450px',
              // isMd ? '-450px' : '-250px'
            },
            left: 0,
            zIndex: -1,
          }}
        ></Box>
        <Container
          paddingY={{ xs: 4, sm: 4, md: 8 }}
          data-aos={isMd ? 'fade-right' : 'fade-up'}
        >
          <Box
            sx={{
              textAlign: 'center',
              mt: {
                xs: 3,
                sm: 3,
                md: 6,
              },
            }}
          >
            <Typography
              variant="h2"
              gutterBottom
              sx={{
                fontWeight: 700,
                color: '#171C61',
              }}
            >
              {t('title')}
            </Typography>
          </Box>
          <Box
            sx={{
              textAlign: 'center',
              my: {
                xs: 3,
                sm: 3,
                md: 6,
              },
            }}
          >
            <Typography
              variant="h6"
              // color="text.primary"
              gutterBottom
              sx={{
                fontWeight: 400,
                color: '#000',
              }}
            >
              {t('subTitle')}
            </Typography>
          </Box>
          {isMd ? (
            <SailEmail
              containerSx={{
                maxWidth: '480px',
              }}
              inputStyle={{
                maxWidth: '320px',
              }}
            />
          ) : (
            <SailEmail
              inputStyle={{
                fontSize: '16px',
                maxWidth: '165px',
              }}
              buttonStyle={{
                padding: '8px 12px',
                fontSize: '16px',
              }}
            />
          )}
          <Box
            sx={{
              display: {
                xs: 'none',
                md: 'flex',
              },
              mt: {
                md: 15,
              },
              mb: {
                md: 12,
              },
              textAlign: 'center',
              height: 600,
              position: 'relative',
              overflow: 'hidden', // 防止图像溢出
            }}
          >
            <Image
              src={HomeTopic}
              alt="sailglobal home logo"
              style={{
                width: '100%', // 宽度占满容器
                height: '100%', // 高度占满容器
                objectFit: 'contain', // 保持宽高比，完整显示图像
                objectPosition: 'center', // 图像居中显示
              }}
            />
          </Box>
          <Box
            sx={{
              display: {
                xs: 'flex',
                md: 'none',
              },
              textAlign: 'center',
              maxHeight: '450px',
              position: 'relative',
              mt: 5,
            }}
          >
            <Image
              src={HomeTopic}
              alt="sailglobal home logo"
              style={{
                width: '100%', // 宽度占满容器
                height: '100%', // 高度占满容器
                objectFit: 'scale-down', // 保持宽高比，完整显示图像
                objectPosition: 'center', // 图像居中显示
              }}
            />
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Hero;
